import { Box, Tooltip } from '@mui/material'
import { observer } from 'mobx-react'
import React, { FC } from 'react'
import { Control } from 'react-hook-form'
import FormField from '../../../../../components/Form/FormField'
import FormAutocomplete from '../../../../SingleRequestPage/components/SingleRequestDrawer/elements/FormAutocomplete'
import {
  PossibleMalfunction,
  ServiceCenterForm,
} from '../types/NewDrawers.types'

interface NewServiceResultsDrawerProps {
  possibleMalfunctions?: PossibleMalfunction[]
  control: Control<ServiceCenterForm, any>
  malfunctionError: boolean
  malfunctionText: string
}

const CheckedForm: FC<NewServiceResultsDrawerProps> = ({
  possibleMalfunctions,
  control,
  malfunctionError,
  malfunctionText,
}) => {
  return (
    <>
      <FormAutocomplete
        control={control}
        name='receiverModelName'
        fullWidth
        label='Модель оборудования'
        withoutTyping
        options={[]}
        disabled
      />

      <Tooltip
        placement='top'
        title={malfunctionText}
        disableHoverListener={malfunctionError}
      >
        <Box position={'relative'}>
          <FormAutocomplete
            control={control}
            name='serviceCenterMalfunctionId'
            fullWidth
            label='Тип неисправности от Сервис-центра'
            withoutTyping
            options={possibleMalfunctions?.map((r) => r.name) || []}
            error={malfunctionError}
            fullHeight
            withClearBtn
          />
        </Box>
      </Tooltip>
      <FormField
        control={control}
        name='serviceCenterComment'
        fullWidth
        placeholder=''
        label='Комментарий для СЦ'
        multiline
        rows={2}
      />
    </>
  )
}

export default observer(CheckedForm)
